import axios from "axios"
import { mockTopStudents, mockStudents, mockLabs } from "../mocks/mockData"

const $host = axios.create({
    baseURL: '/api'
})

export async function fetchStudentsWithGrades() {
    try {
        const { data } = await $host.get("/students/grades")
        return data
    } catch (error) {
        console.error("Ошибка при получении студентов и их оценок", error)
        return { students: [], labs: []}
    }
    // return Promise.resolve({ students: mockStudents, labs: mockLabs });
}

export async function fetchTopStudents() {
    try {
        const { data } = await $host.get("/students/best")
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error("Ошибка при получении лучших студентов", error)
        return [];
    }
    // return Promise.resolve(mockTopStudents)
}

export {
    $host
}